<main class="main-home-secton">
    <div class="event-main">
        <div class="div-header">
            <h1>Newsletters</h1>
        </div>
       <div class="container">
        <div class="row" *ngIf="disList">
            <div class="col-lg-4 col-md-6 col-12" *ngFor="let list of disList; let i=index">
                <div class="card newsletter_dev " style="height: 320px;">
                    <div class="logo-image text-center">
                    <img  [src]="list.incubatorLogoFile" alt="">
                </div>
                   <div style="padding: 20px;">
                        <h5 class="newsheading">{{ list.title }}</h5>
                        <div class="d-flex">
                            <span><span style="font-size: 12px;color:gray;margin-left: 3px;">Posted : </span>{{ list.newsletterDate }}</span>
                            <span class="ml-auto"><a [href]="list.newsletterName" target="_blank" style="color:orange" (click)="viewmore()">View more</a></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center" *ngIf="disList.length === 0">
            <div class="no-data-div image-align">
                <img style="width:450px;" src="assets/images/startupTn-new-logo.png" class="img-fluid" alt="">
                <h6>Coming soon</h6>
            </div>
        </div>
    </div>
    <div class="pagination-div text-center m-3" *ngIf="totalPages>1">
        <button mat-mini-fab color="accent" class="set-page mr-2" [disabled]="currentPage == 1"
            (click)="paginatePartList('prev')"><i class="fas fa-chevron-left"></i></button>
        <button mat-mini-fab color="accent" class="set-page" [disabled]="currentPage == totalPages"
            (click)="paginatePartList('next')"><i class="fas fa-chevron-right"></i></button>
    </div>
     </div>
</main>